import { render, staticRenderFns } from "./VrmTag.vue?vue&type=template&id=18a3038e&"
import script from "./VrmTag.vue?vue&type=script&lang=js&"
export * from "./VrmTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports